import { createFileRoute } from "@tanstack/react-router";
import { TeamPage } from "./-lib/team-page";

export const Route = createFileRoute("/settings/team/")({
  component: TeamPage,
});
